module.exports = __webpack_public_path__ + "img/mega.3ddd2d82.png";